import React, { Component } from 'react';
import ScrollToTop from 'react-scroll-to-top';
import NavMenu from './NavMenu';
import Footer from './Footer';

export class PrivacyPolicy extends Component {
    static displayName = PrivacyPolicy.name;

    constructor(props) {
        super(props);
        this.state = {
            title: 'Privacy Policy and Notice of Collection',
            contentHtml: null,
            errorMessage: null,
            loading: true
        };
    }

    componentDidMount() {
        this.fetchPrivacyContent();
    }

    async fetchPrivacyContent() {
        try {
            const response = await fetch('/api/aht/Privacy');

            if (!response.ok) {
                throw new Error('Failed to load privacy policy');
            }

            const data = await response.json();

            this.setState({
                title: data.title || 'Privacy Policy and Notice of Collection',
                contentHtml: data.contentHtml,
                errorMessage: data.errorMessage,
                loading: false
            });
        } catch (error) {
            console.error('Error fetching privacy policy:', error);
            this.setState({
                errorMessage: 'Unable to load privacy policy. Please try again later.',
                loading: false
            });
        }
    }

    renderContent(showPageLayout) {
        const { title, contentHtml, errorMessage, loading } = this.state;

        return (
            <section className="contact" style={showPageLayout ? { paddingTop: '120px' } : undefined}>
                <div className="container" data-aos="fade-up">
                    <div className="php-email-form p-3 p-md-4">
                        <h1>{title}</h1>

                        {loading && <p>Loading privacy policy...</p>}

                        {errorMessage && (
                            <p className="text-danger">{errorMessage}</p>
                        )}

                        {!loading && !errorMessage && contentHtml && (
                            <div dangerouslySetInnerHTML={{ __html: contentHtml }} />
                        )}
                    </div>
                </div>
            </section>
        );
    }

    render() {
        const showPageLayout = this.props.showPageLayout ?? true;

        if (!showPageLayout) {
            return <div>{this.renderContent(false)}</div>;
        }

        return (
            <>
                <ScrollToTop className="scroll-top d-flex align-items-center justify-content-center active" />
                <NavMenu />
                {this.renderContent(true)}
                <Footer />
            </>
        );
    }
}

export default PrivacyPolicy;
